module.exports = __webpack_public_path__ + "static/img/Y1D20.686cc42.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Y1D20.png
// module id = ur0z
// module chunks = 2